
export default {
  'm': {
    'sms_login': 'Anmeldung per Kurznachricht',
    'get_vercode': 'Senden',
    'change_mobile': 'Telefonnummer ändern',
    'log_reg_agree': 'Anmelden/Registrieren bedeutet {msg_ss} zustimmen',
    'old_mobile': 'Ursprüngliche Telefonnummer',
    'new_mobile': 'Neue Telefonnummer',
    'agency_reginfo_fill': 'Füllen Sie die Gildenregistrierungsinformationen aus',
    'audit_res': 'Audit-Ergebnisse',
    'agency_name': 'Gildenname',
    'agency_name_input': 'Bitte geben Sie einen Gildennamen ein',
    'agency_name_input_note': 'Hinweis: Der Gildenname sollte kurz und leicht zu merken sein, nicht mehr als 30 Wörter',
    'agency_logo': 'Gilden-LOGO',
    'agency_logo_unpload_note': 'Bitte lade ein deutliches Gilden-LOGO im PNG/JPG/JPEG-Format hoch',
    'agency_contact_name': 'Ansprechpartner Gilde',
    'user_contact_name': 'Bitte tragen Sie den Namen der Person ein, die täglich mit der Benutzerplattform in Kontakt steht',
    'agency_contact_phone': 'Telefonnummer des Gildenkontakts',
    'agency_whatsapp': 'Gildenleiter WhatsApp',
    'agency_whatsapp_contact': 'Bitte geben Sie die WhatsApp-Kontaktdaten des Gildenleiters ein',
    'agency_use_lang': 'Vom Gildenleiter verwendete Sprache',
    'agency_head_ID': 'ID des Gildenleiters',
    'agency_ID_input': 'Geben Sie die BuzzCast App-Benutzer-ID für den Agenten ein, der später zur Verteilung der Gelder verwendet wird.',
    'reg_country': 'Land der Registrierung',
    'inhand_ID_photo': 'Lichtbildausweis vorhanden',
    'upload_note_t': 'Hinweis zum Laden',
    'agency_self_inhand_ID': 'Es muss vom Beauftragten selbst mit dem Passdokument mitgeführt werden',
    'photo_must_clearly': 'Die Vorderseite muss die Person und die echten Passinformationen durch Fotografieren deutlich zeigen',
    'mian_form_country': 'Das Hauptherkunftsland des Gastgebers',
    'invite_code': 'Einladungscode',
    'your_profile_submit_success': 'Ihr Dokument wurde erfolgreich übermittelt! Wir werden uns so schnell wie möglich darum kümmern.<br>Die Audit-Ergebnisse werden an die BuzzCast APP-Benachrichtigung des Gildenleiters gesendet, und bitte achten Sie darauf, sie zu überprüfen!',
    'your_profile_approved': 'Das von Ihnen eingereichte Dokument hat die Überprüfung nicht bestanden! Der Grund für die Ablehnung ist, dass das Foto des Inhaberpasses nicht klar ist".<br>Bitte füllen Sie das Formular erneut aus oder wenden Sie sich zur Beratung an den offiziellen Assistenten von BuzzCastAPP.',
    'return_refill': 'Gehen Sie zurück und füllen Sie nach',
    'success_agency': 'Herzlichen Glückwunsch zu Ihrer erfolgreichen Einrichtung der Plattform, [klicken Sie auf mich], um mit der Arbeit zu beginnen!',
    'personal_account': 'Persönliches Konto',
    'my_agency': 'Meine Gilde',
    'your_agency_been_forcibly': 'Ihre Gilde wurde von der Plattform zwangsweise aufgelöst und Sie können sich nicht mehr beim System anmelden. Bei Fragen wenden Sie sich bitte an den offiziellen Assistenten von BuzzCastAPP oder den exklusiven Betrieb.',
    'invite_live_join': 'Host zum Gildenbeitritt einladen Link',
    'base_info': 'Grundinformation',
    'apply_time': 'Antragsdatum',
    'join_time': 'Zeit mitmachen',
    'cooper_status': 'Kooperationsstatus',
    'streamer_manage': 'Host-Verwaltung',
    'sereamer_apply': 'Host-Zulassung',
    'sereamer_nickname': 'Spitzname des Hosts',
    'remark': 'Anmerkung',
    'no_remark': 'Keine Bemerkungen',
    'add_remark': 'Bemerkungen hinzufügen',
    'birth': 'Geburtsdatum',
    'user_status': 'Benutzerstatus',
    'temporarily_frozen': 'Vorübergehendes Einfrieren',
    'permanently_frozen': 'Für immer einfrieren',
    'fans_num': 'Anzahl der Follower',
    'sign_status': 'Vertragsstatus',
    'sign_ing': 'Unter Vertrag',
    'sign_time': 'Vertragsdatum',
    'release_time': 'Kündigungsdatum',
    'live_viola_record': 'Aufzeichnungen über Verstöße gegen Live-Übertragungen',
    'sign_record': 'Vertragsaufzeichnung',
    'current_contract_status': 'Aktueller Vertragsstatus',
    'termination_reason': 'Kündigungsgrund',
    'violation_reason': 'Grund des Verstoßes',
    'violation_time': 'Datum des Verstoßes',
    'processing_result': 'Ergebnis verarbeiten',
    'exported_data': 'Daten exportieren',
    'join_agency_apply': 'Genehmigung zum Gildenbeitritt',
    'audit_status': 'Genehmigter Status',
    'pending_review': 'Ausstehende Bewertung',
    'pending_HQ_review': 'Warten auf Überprüfung durch das Hauptquartier',
    'not_approved_HQ': 'Von der Zentrale nicht zugelassen',
    'withdrawn': 'Widerrufen',
    'audit_trail': 'Aufzeichnungen überprüfen',
    'oper': 'Betrieb',
    'other_video_materials': 'Weitere Videodokumente',
    'pass': 'Passieren',
    'pass_streamer_join_agency_apply': 'Nehmen Sie den Ankermitgliedschaftsantrag an',
    'reject_streamer_join_agency_apply': 'Antrag auf Gildenbeitritt des Gastgebers ablehnen',
    'agree_streamer_join_agency': 'Stimmen Sie Anker {msg_ss1} zu, ein Absender unterhalb von {msg_ss2}~ zu werden',
    'reject_streamer_join_agency': 'Der Antrag von Mitglied {msg_ss1}, Mitglied von {msg_ss2} zu werden, wird abgelehnt!',
    'img_material': 'Bilddokumente',
    'approver': 'Genehmiger',
    'user_enter_bind_phone': 'Bitte geben Sie die Telefonnummer ein',
    'vericode': 'Bestätigungscode',
    'input_vericode': 'Bitte geben Sie den Bestätigungscode ein',
    'login': 'Einloggen',
    'reg': 'Eingetragen',
    'logout': 'Ausloggen',
    'search_for': 'Suchen',
    'subscription_closed': 'Vertrag gekündigt',
    'agency_ID': 'Gildencode: {msg_ss}',
    'reset': 'Zurücksetzen mit',
    'live_ID': 'Host ID',
    'live_record': 'Live-Broadcast-Bildschirmaufnahme',
    'email': 'E-Mail-Adresse',
    'phone': 'Telefonnummer',
    'mastery_lang': 'Beherrschungssprache',
    'to': 'Bis zu',
    'cancel': 'Abbrechen',
    'Confirm': 'OK',
    'preview': 'Vorschau',
    'rejected': 'Abgelehnt',
    'tip': 'Eingabeaufforderung',
    'i_got_it': 'Ich habe es',
    'cancelled': 'Abgesagt',
    'refused': 'Ablehnen',
    'agency_agree': 'Gilde hat zugestimmt',
    'platform_agree': 'Plattform hat zugestimmt',
    'user_not_exist': 'Dieser Benutzer existiert nicht',
    'user_frozen': 'Der Benutzer wurde eingefroren',
    'reviewing': 'Im Rückblick',
    'review_pass': 'Überprüfung bestanden',
    'review_failed': 'Audit fehlgeschlagen',
    'xx_hours': '{msg_ss} stunden',
    'xx_days': '{msg_ss} tage',
    'xx_hour': '{msg_ss} Stunde',
    'xx_day': '{msg_ss} Tag',
    'xx_year': '{msg_ss} Jahr',
    'xx_years': '{msg_ss} Jahre',
    'check_phone_istrue': 'Bitte überprüfen Sie, ob die Telefonnummer richtig eingegeben wurde',
    'male': 'Männlich',
    'female': 'Weiblich',
    'avatar': 'Profilfoto',
    'normal': 'Normal',
    'live_room': 'Live-Übertragungsraum',
    'view': 'Ansehen',
    'oper_success': 'Erfolgreicher Vorgang',
    'copy_success': 'Erfolgreiche Kopie',
    'new_mobile_already_reg': 'Neue Handynummer ist registriert',
    'general_user': 'Allgemeiner Benutzer',

    'copy': 'Kopieren',
    'gender': 'Geschlecht',
    'submit': 'Einreichen',
    'permanent': 'Permanent',
    'agree_agreement': 'Dem Vertrag zustimmen und ihn einhalten',
    'vericode_error': 'Der Verifizierungscode ist falsch',
    'resend': 'Stornieren',
    'approved': 'Bestanden',
    'not_approved': 'Nicht bestanden',
    'agency_rejected': 'Plattform abgelehnt',
    'select': 'Wahlen',
    'search': 'Suchen',
    'rejection_reason': 'Grund für die Ablehnung',
    'no_data': 'Daten null',
    'oper_failed': 'Operation fehlgeschlagen',
    'leave_agency_apply': 'Zustimmung zum Austritt aus der Gilde',
    'over_word_limit': 'Maximales Eingeben',
    'delete': 'Löschen',
    'nickname': 'Kosename',
    'file_is_too_large': 'Zu große Datei',

    'community_convention': 'Buzzcast Community Convention',
    'approval_time': 'Die Prüfungs- und Genehmigungszeit',
    'guild_system_title': 'Gildensystem der sozialen BuzzCast-Plattform',
    'return': 'Zurückkehren',
    'img_upload_fail': 'Bild-Upload fehlgeschlagen',
    'cooper_ing': 'In Zusammenarbeit',
    'upload_file_format_incorrect': 'Die hochgeladene Datei hat nicht das richtige Format',
    'token_invalid': 'Token ist ungültig, bitte melden Sie sich erneut an!',
    'network_busy': 'Das Netzwerk ist ausgelastet. Bitte versuchen Sie es erneut',
    'minute': '{msg_ss}Minute',

    'live_room_ID': 'Live-Übertragungsraum ID',

    'scan_code': 'BuzzCast APP-Scancode zum Anmelden',
    'open_code': 'Öffnen Sie die BuzzCast-APP, klicken Sie zum Scannen auf meinen QR-Code',
    'refresh': 'Aktualisieren',
    'login_confirm': 'Login-Bestätigung',
    'account': 'Kontoinformationen',
    'user_name': 'Benutzername',
    'edit': 'Korrigieren',
    'changing': 'Bindung ändern',
    'mobile_number': 'Telefonkonto',
    'mobile_login': 'Sie können sich mit Ihrer Handynummer {msg_ss} anmelden',
    'appId_login': 'Sie können das Konto verwenden, dessen AppID [{msg_ss}] ist, um zu scannen und sich anzumelden',
    'code_login': 'BuzzCastAppID ist nicht gebunden, nach der Bindung können Sie den QR-Code verwenden, um den Code zu scannen, um sich anzumelden',
    'verification_log': 'Die Mobiltelefonnummer ist nicht gebunden, nach der Bindung können Sie sich mit der Mobiltelefonnummer und dem Verifizierungscode anmelden',
    'binding_success': 'Bindung erfolgreich',
    'binding_mobile': 'Handynummer binden',
    'edit_name': 'Benutzernamen ändern',
    'binding_alert': 'Tipps zum Bindungswechsel',
    'new_appId': 'Verwenden Sie direkt die neue APPID-Scancodebindung, die ursprüngliche APPID wird direkt ersetzt',
    'binding_account': 'Binden Sie das BuzzCastApp-Konto',
    'anchor_earings': 'Ankereinkommen',
    'signing_date': 'Vertragsdatum',
    'statistical_date': 'Datum der Statistik',
    'valid_min': 'Effektive Gesamtzeit (Minuten)',
    'valid_day': 'Gültige Tage (Tage)',
    'total_revenue': 'Gesamteinnahmen',

    'bind': 'Bind',
    'please_agree_agree': 'Bitte stimmen Sie dem Vertrag zu',
    'note': 'Hinweis: Die von diesem System angezeigte Zeit ist New Yorker Zeit (EST)',
    'app_phone': 'Registrieren Sie die Mobiltelefonnummer der APP',
    'host_num': 'Nummer des Hosts',
    'enter_host_num': 'Bitte geben Sie die Nummer aller Hosts ein',
    'platform': 'Kooperationsplattform',
    'statement': 'Monatlicher Kontoauszug',
    'enter_income': 'Bitte tragen Sie das durchschnittliche monatliche Einkommen ein',
    'check_commas': 'Falsches Format. Bitte überprüfen Sie, ob die mehreren Plattformen durch Kommas getrennt sind',
    'submit_success': 'Ihr Dokument wurde erfolgreich übermittelt! Wir werden uns so schnell wie möglich darum kümmern',
    'usd': 'USD',
    'many_platforms': 'Bitte geben Sie die Live-Übertragungsplattform ein, mit der Sie zuvor zusammengearbeitet haben, bis zu 20 Plattformen',
    'limit_platform': 'Bis zu 20 Plattformen',
    'user_has_delete': 'Der Benutzer wurde storniert',
    'cant_commit': 'Sie sind bereits ein unter Vertrag stehender Broadcaster und können sich nicht gleichzeitig für eine Gilde bewerben',
    'cant_commit_1': 'Sie haben sich bereits bei einem Vertragssender beworben und können sich nicht gleichzeitig für eine Gilde bewerben',
    'passwd': 'Passwort',
    'passwd_placeholder': 'Ihr Passwort soll aus 6 bis 20 Zeichen bestehen.',
    'live_rights': 'Zeitfreie Bewertung',
    'edit_log': 'Datensatz ändern',
    'edit_time': 'Ändere die Zeit',
    'edit_pwd': 'Kennwort ändern',
    'old_pwd': 'Altes Kennwort',
    'new_pwd': 'Neues Kennwort',
    'confirm_pwd': 'Bestätige das Passwort',
    'forget_pwd': 'Passwort vergessen?',
    'email_check': 'Das E-Mail-Format ist falsch.',
    'phone_pwd_error': 'Falsche Handynummer oder Passwort',
    'ten_min_error': 'Bitte versuchen Sie es in 10 Minuten erneut',
    'phone_bind_error': 'Die Mobiltelefonnummer wurde an andere Konten gebunden, bitte ersetzen Sie die neue Mobiltelefonnummer, um zu binden.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'Die Gildenleiter-ID wurde bereits ausgefüllt, bitte erneut ausfüllen',
    'pwd_error': 'Falsches Passwort',
    'phone_not_reg_error': 'Konto ist nicht registriert',
    'pwd_nq': 'Die neu eingegebenen Kennwörter sind inkonsistent',
    'sign_anchor_error': 'Sie sind bereits ein unter Vertrag stehender Broadcaster und können sich nicht gleichzeitig für eine Gilde bewerben',
    'apply_anchor_error': 'Sie haben sich bereits bei einem Vertragssender beworben und können sich nicht gleichzeitig für eine Gilde bewerben',
    'have-expired': 'Abgelaufen',
    'approval-time': 'Bearbeitungszeit',
    'reasons-for-refusal': 'Bitte geben Sie einen Ablehnungsgrund ein',
    'Transfer-grounds': 'Grund für die Versetzung:',
    'code_expire': 'Der Bestätigungscode ist abgelaufen, bitte klicken Sie auf den Bestätigungscode, um ihn zu aktualisieren',
    'transfer-approval': 'Genehmigung der Versetzung',
    'live_state_placeholder': 'Der Status des Starts des Live-Streams',
    'live_state_open': 'Normal',
    'live_state_temporary_banned': 'Live-Streaming ist verboten',
    'live_state_forever_banned': 'Dauerhaftes Verbot',
    'live_allowed_time': 'Die Uhrzeit, zu der der Live-Stream beginnen kann',
    'live_banned_time': 'Live-Streaming-Zeit verbieten',
    'deduct_money': 'Betrag B abziehen',
    'final_income': 'Reales Einkommen',
    'select_start_dt': 'Bitte wählen Sie eine Startzeit',
    'select_end_dt': 'Bitte wählen Sie eine Endzeit',
    'less_then_end_dt': 'Die Startzeit muss kleiner oder gleich der Endzeit sein',
    'System_automatically_through': 'Das System besteht automatisch',
    'btrade_err': 'Die Agentur-ID ist nicht verfügbar',

    'mouth_anchor': 'Monatgehalt des Hosts',
    'day_anchor': 'Tagesgehalt des Hosts',
    'guild_anchor': 'Belohnungen des Gildenpräsidenten (Tagesgehalt)',
    'mouth_anchor_st': 'Anfangszeit des Monatgehalts',
    'mouth_anchor_et': 'Endzeit des Monatgehalts',
    'day_anchor_st': 'Anfangszeit des Tagesgehalts',
    'day_anchor_et': 'Endzeit des Tagesgehalts',
    'all_award_bcoin': 'Gesamtgewinne der Tagesgehaltsbelohnungen',
    'live_hour': 'Belohnungen der gültigen Live-Show-Stunden',
    'salary_day': 'Datum',
    'day_in_come': 'Gildengewinne für den selben Tag (B-Münze)',
    'award_ration_flag_str': 'Belohnungsverhältnis',
    'payable_money': 'B-Münze-Belohnungen des Gildenpräsidenten',
    'host_bcoins': 'B-Münzen (Einnahmen des Hosts)',
    'total_official': 'Gesamtzahl der B-Münzen (Offizielle Belohnungen)',
    'actual_bcoins_awarded': 'B-Münzen (Tatsächliche Belohnungen)',
    "change_bound_account":"Gebundenes Konto ändern" ,
    "agent_id_form":"Guildenleiter-ID:" ,
    "BuzzCast_verification_code":"BuzzCast-Verifizierungscode:" ,
    "send_success":"Erfolgreich senden" ,
    "account_changed_successfully":"Gebundenes Konto erfolgreich gewechselt." ,
    "invite_guild_url":"Link zur Einladung zum BuzzCast-Guildenleiter: {msg_ss}" ,
    "invite_guild_code":"Mein Einladungscode: {msg_ss}" ,
    "save":"Speichern" ,
    "compile":"Bearbeiten" ,
    "agent_nvitation_eward":"Guildenleiter-Einladungsbelohnung" ,
    "agent_name":"Spitzname des Guildenleiters" ,
    "guild_id":"Gilden-Code" ,
    "guild_income_30days":"Gilden-Einnahmen in den letzten 30 Tagen" ,
    "guild_invite_income_30days":"Gilden-Einladungseinnahmen in den letzten 30 Tagen" ,
    "agency_commission_ratio":"Agentur-Provisionsrate" ,
    "invite_income_bcoins":"Einladung belohnt B-Münzen" ,
    "id_not_exist": "Die ID existiert nicht",
    'reward_distribution_status': 'Status der Prämienverteilung',
    'must_number': 'Ihre Eingabe muss im rein numerischen Format erfolgen.',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/de.js